import React from "react";
import { Link, useLocation } from "react-router-dom";
import { formatPrice, siteConfig } from "../Datas/productData";
import "../css/paysuccess.css";

const PaySuccess = () => {
  const { brandName, contact } = siteConfig;
  const { state } = useLocation();
  const hasRecentOrder = Boolean(state?.orderReference);

  return (
    <main className="successDiv pay-success" id="main-content" tabIndex="-1">
      <section className="pay-success__panel" aria-labelledby="success-title">
        {hasRecentOrder && (
          <div className="pay-success__mark" aria-hidden="true">
            <span />
          </div>
        )}
        <p className="pay-success__eyebrow">
          {hasRecentOrder ? "Checkout complete" : "No recent checkout"}
        </p>
        <h1 id="success-title">
          {hasRecentOrder ? "Thank you." : "Nothing to confirm."}
        </h1>
        <p className="pay-success__lead">
          {hasRecentOrder
            ? `Your demo checkout has been completed. Thanks for choosing ${brandName}.`
            : "Complete the demo checkout flow before viewing an order confirmation."}
        </p>

        {hasRecentOrder && (
          <dl className="pay-success__order">
            <div>
              <dt>Reference</dt>
              <dd>{state.orderReference}</dd>
            </div>
            <div>
              <dt>Total</dt>
              <dd>{formatPrice(state.total)}</dd>
            </div>
          </dl>
        )}

        {hasRecentOrder && <div className="pay-success__timeline" aria-label="Order next steps">
          <article>
            <span>01</span>
            <div>
              <h2>Confirmation</h2>
              <p>A live store would email your order summary immediately.</p>
            </div>
          </article>
          <article>
            <span>02</span>
            <div>
              <h2>Preparation</h2>
              <p>The studio would carefully prepare and inspect every item.</p>
            </div>
          </article>
          <article>
            <span>03</span>
            <div>
              <h2>Dispatch</h2>
              <p>A tracking link would follow when the parcel leaves.</p>
            </div>
          </article>
        </div>}

        <aside className="pay-success__notice" role="note">
          <strong>Demo checkout</strong>
          <p>
            {hasRecentOrder
              ? "No payment was captured and no real order was created. Connect a payment and order service before using this flow in production."
              : "There is no order attached to this page. Return to the shop to begin the simulated purchase flow."}
          </p>
        </aside>

        <div className="pay-success__actions">
          <Link to="/shop">Continue shopping</Link>
          <Link to="/">Return home</Link>
        </div>
        <p className="pay-success__support">
          Need help? <a href={`mailto:${contact.email}`}>{contact.email}</a>
        </p>
      </section>
    </main>
  );
};

export default PaySuccess;
